<script>
  import { onMount, createEventDispatcher } from "svelte"
  import notify from "../../../../../../Script/notify"
  import { getRequest } from "../../../../../../Script/apiMethods"
  import { EMAIL_REGEX } from "../Script/utils"
  import { drawSign } from "../../../../SingleDocket/Script/sign"
  import SignWidget from "./signWidget.svelte"
  import ApplicationState from "../../../../../../Stores/applicationStates"
  import SealList from "./sealList.svelte"
  import Input from "./input.svelte"
  import { allowedSpclCharsRegex, allowedSpclCharsRegexInMultiSigner, replaceSpclCharsRegex, replaceSpclCharsRegexInMultiSigner } from "../../../../../../Script/regex"
  const dispatch = createEventDispatcher()

  export let user
  export let index
  export let approvers = []
  export let isPdfDigitallySigned = false
  export let isPublishEnabled = false
  export let sealCount = 0
  export let seals = []
  export let sealMaxCount = 0
  export let sealEndCount = 0

  let isUIEnabled = false
  let isUserChecked = false
  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  let disableAddSignBtn = false
  /**
   * @type {HTMLInputElement}
   */
  let emailInput

  export let currentpage

  export let totalPages

  let isError = false

  let tempName = ""

  onMount(() => {
    try {
      if (user.hasOwnProperty("internal")) isUserChecked = true
      if (user.placements.length != 0) isUIEnabled = true
      if (!user.email) emailInput?.focus()
      // user.email = "gowtham@email.com"
    } catch (error) {
      console.error(error)
    }
  })

  const addSignField = async (e) => {
    try {
      console.log(user.seal)
      console.log(e.target.checked)
      if (!e.target.checked) {
        user.placements = []
        isUIEnabled = e.target.checked
        return
      }

      closeNotification.close()
      user.name = user.name.trim()
      if (!user.name) throw "Kindly enter approver name"
      if (!user.email) throw "Kindly enter approver email"
      if (!EMAIL_REGEX.test(user.email)) throw "Kindly  enter valid email address"
      // if (!isPdfDigitallySigned && user.internal) {
      //   if (!seals.length) throw "Kindly create a seal and continue"
      //   if (!user.seal) throw "Kindly select seal"
      // }

      user.error = false

      const signDetails = {
        name: user.name,
        role: user.role,
        showQR: isPublishEnabled,
      }

      disableAddSignBtn = true

      let eSignURL = await drawSign(signDetails)

      const placement = {}
      placement.id = Date.now() + Math.floor(Math.random() * 10000 + 1)
      placement.pages = currentpage - 1
      user.placements = [...user.placements, placement]
      user.sign = eSignURL

      isUIEnabled = e.target.checked
    } catch (error) {
      console.error(error)
      isUIEnabled = e.target.checked = false
      const info = "PAGE: Docket Creation\nEVENT: While adding signature placement for approver"
      closeNotification = notify.danger(error, info)
    } finally {
      disableAddSignBtn = false
    }
  }

  const deletePlacement = () => {
    try {
      user.placements = []
      isUIEnabled = false
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: While deleting signature field for approver"
      closeNotification = notify.danger(error, info)
    }
  }

  const checkInternalUser = async () => {
    try {
      const REQ_URL = `/api/pdf-signing/v2/internal/signers/by-email?email=${user.email}`
      const CONFIG = {
        headers: {
          "msign-org-token": $ApplicationState.msignToken,
        },
      }

      const { signer } = await getRequest(REQ_URL, CONFIG)

      user.name = signer.name
      user.designation = signer.designation || user.designation
      user.mode = "PFX-SIGN"
      user.internal = true
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  const handleInternalCheck = async () => {
    try {
      if (isUserChecked) {
        user.email = user.designation = user.name = user.seal = user.sealName = user.sealImg = ""
        user.placements = []
        delete user.internal
        isUIEnabled = isUserChecked = false
        return
      }
      user.email = user.email.trim().toLowerCase()
      if (!user.email) throw "Kindly enter approver email"
      if (!EMAIL_REGEX.test(user.email)) throw "Kindly enter valid email address"

      let emailList = approvers.filter((approver) => approver.name).map((approver) => approver.email)

      if (approvers.length > 1 && emailList.includes(user.email)) {
        // let index = emailList.indexOf(user.email) + 1
        let filteredApprovers = approvers.filter((item) => item.email == user.email)
        let approverName = filteredApprovers[0].name || filteredApprovers[1].name
        throw `Approver named as ${approverName} already found with same email address`
      }

      try {
        await checkInternalUser()
      } catch (error) {
        console.error(error)
        user.internal = false
      } finally {
        user.error = false
      }

      isUserChecked = true

      setTimeout(() => {
        let userNameInput = document.getElementById(`userName ${user.id}`)
        if (userNameInput) userNameInput.focus()
      }, 10)
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: While checking whether the approver is internal or external"
      closeNotification = notify.danger(error, info)
    }
  }

  const handleNameBlur = async () => {
    try {
      user.name = user.name.trim()
      if (user.placements.length != 0 && user.name) {
        user.error = false
        let currentName = user.name
        if (tempName != currentName && !user.internal) {
          disableAddSignBtn = true
          const signDetails = {
            name: user.name,
            role: user.role,
            showQR: isPublishEnabled,
          }

          user.sign = await drawSign(signDetails)
        }
      }
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Docket Creation\nEVENT: While updating sign placement on approver name change"
      closeNotification = notify.danger(error, info)
    } finally {
      disableAddSignBtn = false
    }
  }

  $: checkError(user.placements, user.error)

  const checkError = () => {
    let errorPlacements = user.placements.filter((placement) => placement.error) || []
    isError = Boolean(errorPlacements.length) || user.error
  }
</script>

<div class=" w-full">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    on:click={() => {
      user.active = !user.active
      if (user.active) dispatch("active")
    }}
    class="{isError ? 'bg-red-500 text-white hover:bg-red-600 dark:bg-red-500 dark:text-white dark:hover:bg-red-600' : `${user.active ? 'bg-blue-500 text-white' : 'bg-[#f7f7f7] text-gray-d00 hover:bg-blue-500 hover:text-white dark:bg-gray-c00 dark:text-white hover:dark:bg-blue-500 hover:dark:text-white'}`} flex cursor-pointer select-none items-center justify-between gap-3 {user.active ? 'rounded-t-md' : 'rounded-md'} py-2 px-3"
  >
    <div class="flex items-center truncate">
      <div class="flex items-center justify-center">
        <i class="fa-solid fa-file-signature" />
      </div>
      &nbsp;&nbsp;
      <span>{user.name.trim() || `Approver ${index + 1}`}</span>
    </div>
    <button data-tooltip="Delete Approver" tooltip-position="left" type="button" on:click|stopPropagation class={isError ? "" : "hover:text-red-500"}>
      <span>
        <i class="fa-solid fa-trash-can" />
      </span>
    </button>
  </div>

  {#if user.active}
    <div class="space-y-3 rounded-b-md border-x-2 border-b-2 {isError ? 'border-red-500' : 'border-blue-500'} p-3">
      <form on:submit|preventDefault={handleInternalCheck} class="flex gap-2">
        <div class="group relative w-full rounded-md">
          <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-blue-500">
            <span data-tooltip="Email" tooltip-position="right">
              <i class="fa-solid fa-envelope" />
            </span>
          </div>
          <input bind:this={emailInput} disabled={isUserChecked} required type="email" placeholder="Enter Email" bind:value={user.email} class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-9 pr-3 text-sm text-black outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 dark:text-white" />
        </div>

        <!-- <button type="submit" class="rounded-r-md border-y border-r border-stone-700 text-gray-g00 {isUserChecked ? 'hover:text-red-600 ' : 'hover:text-blue-600'} py-1 px-3 text-gray-g00">
          <i class="fa-solid {isUserChecked ? 'fa-xmark' : 'fa-plus'}" />
        </button> -->
        <!-- <i class="fa-solid fa-arrow-right" /> -->
        <button type="submit" class="rounded-md border-stone-700 text-white {isUserChecked ? 'bg-red-500 hover:bg-red-600' : 'bg-blue-500 hover:bg-blue-600'} py-1 px-3 text-gray-g00">
          <i class="fa-solid {isUserChecked ? 'fa-xmark' : 'fa-arrow-right'}" />
        </button>
      </form>

      {#if isUserChecked}
        <Input
          on:focus={() => {
            if (user.placements.length != 0 && user.name) {
              tempName = user.name
            }
          }}
          maxLenght={80}
          on:blur={handleNameBlur}
          disabled={user.internal}
          placeholder="Enter Name"
          tooltip="Name"
          inputName={`userName ${user.id}`}
          replaceRegex={replaceSpclCharsRegexInMultiSigner}
          regex={allowedSpclCharsRegexInMultiSigner}
          userName={user.name.trim() || `Approver ${index + 1}`}
          icon="user"
          bind:value={user.name}
          errorMsg="Only letters and special characters .'- are allowed."
        />

        <!-- <div class="group relative w-full rounded-md">
          <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-blue-500">
            <span data-tooltip="Name" tooltip-position="right">
              <i class="fa-solid fa-user" />
            </span>
          </div>
          <input
            id="userName{user.id}"
            on:focus={() => {
              if (user.placements.length != 0 && user.name) {
                tempName = user.name
              }
            }}
            on:blur={handleNameBlur}
            disabled={user.internal}
            required
            type="text"
            placeholder="Enter Name"
            bind:value={user.name}
            class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-9 text-sm text-black outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 disabled:cursor-not-allowed dark:text-white"
          />
        </div> -->

        <Input disabled={user.internal} maxLenght={150} placeholder="Enter Designation" tooltip="Designation" inputName={`userDesignation ${user.id}`} replaceRegex={replaceSpclCharsRegex} regex={allowedSpclCharsRegex} userName={user.name.trim() || `Approver ${index + 1}`} icon="briefcase" bind:value={user.designation} errorMsg="Only letters, numbers, and special characters -()+&@., are allowed." />

        <!-- <div class="group relative w-full rounded-md">
          <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-blue-500">
            <span data-tooltip="Designation" tooltip-position="right">
              <i class="fa-solid fa-briefcase" />
            </span>
          </div>
          <input
            on:blur={() => {
              user.designation = user.designation.trim()
            }}
            disabled={user.internal}
            type="text"
            placeholder="Enter Designation"
            bind:value={user.designation}
            class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-9 text-sm text-black outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 disabled:cursor-not-allowed dark:text-white"
          />
        </div> -->

        {#if !isPdfDigitallySigned}
          {#if user.internal && seals.length}
            <SealList {sealCount} {seals} {sealMaxCount} {sealEndCount} bind:selectedImg={user.sealImg} bind:selectedName={user.sealName} bind:selectedId={user.seal} />
          {/if}
          <div class="flex items-center gap-3">
            <input on:change={addSignField} id="approveSign{user.id}" type="checkbox" checked={isUIEnabled} class="h-4 w-4 rounded-md" />
            <label for="approveSign{user.id}" class="cursor-pointer text-base font-medium text-blue-500">Require approver's e-signature.</label>
          </div>

          {#if isUIEnabled}
            {#each user.placements as placement, i (placement.id)}
              <SignWidget
                role="Approver"
                {totalPages}
                {currentpage}
                bind:placement
                on:click={deletePlacement}
                on:pageChange={(e) => {
                  const { current, prev } = e.detail
                  dispatch("pageChange", { prevPage: prev, pageNo: current, user: user.id, id: placement.id, coordinate: placement.coordinate })
                }}
                index={i}
              />
            {/each}
          {/if}
        {/if}
      {/if}
    </div>
  {/if}
</div>
